export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    slug: "17cc-pingtai-jieshao",
    title: "17c.c 平台全面介绍：您的一站式内容聚合门户",
    excerpt: "深入了解 17c.c 平台的强大功能与独特优势，探索海量优质内容的无限可能。从资源搜索到内容推荐，17c.c 为您打造极致体验。",
    content: `<h2>关于 17c.c</h2><p>17c.c 是一个专注于优质内容聚合与分发的综合性平台。我们致力于为用户提供最便捷、最高效的内容获取体验，让每一位访问者都能在这里找到所需的信息与资源。</p><p>自平台上线以来，我们始终坚持以用户需求为核心，持续优化内容推荐算法，不断拓展资源覆盖面，力求成为您最值得信赖的首选平台。</p><h3>平台特色</h3><p>17c.c 拥有独特的智能推荐系统，能够根据用户的浏览习惯和偏好，精准推送相关内容。无论是最新资讯、实用教程还是精选资源，都能在 17c.c 上一键获取。</p><p>我们汇聚了来自不同领域的优质创作者，确保平台上每一份内容都经过严格筛选与质量把关，让您远离低质信息的困扰。</p><h3>为什么选择 17c.c</h3><ul><li>海量资源库，覆盖多个领域与主题</li><li>智能推荐引擎，精准匹配您的兴趣</li><li>流畅的用户体验，极速加载与响应</li><li>持续更新的内容，保持新鲜度</li><li>安全可靠的访问环境，保护您的隐私</li></ul>`,
    category: "zixun",
    categoryName: "最新资讯",
    coverImage: "https://readdy.ai/api/search-image?query=A%20modern%20minimalist%20digital%20platform%20dashboard%20showing%20content%20cards%20and%20data%20visualizations%2C%20warm%20orange%20and%20cream%20color%20palette%2C%20clean%20UI%20design%2C%20soft%20natural%20lighting%2C%20abstract%20geometric%20background%20elements%2C%20professional%20editorial%20style%20with%20smooth%20gradients%20and%20elegant%20typography%20layout&width=1600&height=900&seq=article-17cc-intro&orientation=landscape",
    author: "17c.c 编辑部",
    publishDate: "2026-07-28",
    readTime: "8 分钟",
    tags: ["17c.c", "平台介绍", "内容聚合", "使用指南"],
    featured: true,
  },
  {
    slug: "ruhe-gaoxiao-shiyong-17cc",
    title: "17c.c 高效使用指南：从新手到高手的进阶之路",
    excerpt: "掌握 17c.c 平台的正确使用姿势，解锁隐藏功能，让内容获取效率翻倍。本指南涵盖搜索技巧、收藏管理与个性化设置。",
    content: `<h2>快速上手 17c.c</h2><p>刚接触 17c.c？别担心，这篇指南将带您从零开始，快速掌握平台的核心功能与使用技巧。</p><h3>注册与登录</h3><p>访问 17c.c 官网即可体验，无需复杂注册流程。我们为您提供即开即用的便捷体验，让您第一时间开始探索精彩内容。</p><h3>内容浏览技巧</h3><p>17c.c 的分类导航系统经过精心设计，您可以通过顶部导航栏快速切换不同内容板块。每个分类下都有丰富的筛选选项，帮助您精准定位所需资源。</p><h3>搜索功能</h3><p>强大的搜索引擎是 17c.c 的核心优势之一。支持关键词搜索、标签筛选和热度排序，让查找内容变得轻松简单。</p><h3>收藏与分享</h3><p>遇到喜欢的文章或资源？使用收藏功能一键保存，随时回顾。同时支持一键分享到各大社交平台，让优质内容触达更多人。</p>`,
    category: "jiaocheng",
    categoryName: "实用教程",
    coverImage: "https://readdy.ai/api/search-image?query=A%20step%20by%20step%20guide%20illustration%20showing%20a%20person%20exploring%20a%20modern%20web%20platform%20interface%20on%20a%20laptop%2C%20warm%20lighting%2C%20clean%20minimalist%20design%2C%20orange%20accent%20elements%2C%20cream%20background%2C%20flat%20illustration%20style%20with%20soft%20shadows%2C%20editorial%20quality&width=1600&height=900&seq=article-guide&orientation=landscape",
    author: "17c.c 教程组",
    publishDate: "2026-08-01",
    readTime: "10 分钟",
    tags: ["17c.c使用指南", "新手教程", "平台攻略"],
    featured: true,
  },
  {
    slug: "2026-nian-zuijia-ziyuan-zhengli",
    title: "2026 年度最佳资源整理：17c.c 编辑精选合集",
    excerpt: "17c.c 编辑团队精心整理年度最佳资源，涵盖设计素材、开发工具、学习资料等多个维度，助您发现宝藏。",
    content: `<h2>年度资源精选</h2><p>2026 年已经过半，17c.c 编辑团队从平台上线的资源中，精心筛选出最具价值的资源，为您呈现这份年度精选合集。</p><h3>设计素材</h3><p>我们收录了数百套高质量设计素材，包括图标库、字体包、UI 模板等，满足设计师的多样化需求。</p><h3>开发工具</h3><p>从前端框架到后端服务，从代码编辑器到协作平台，我们为您整理了开发者的完整工具箱。</p><h3>学习资料</h3><p>优质在线课程、电子书籍、技术文档，应有尽有。17c.c 助您持续成长。</p>`,
    category: "ziyuan",
    categoryName: "资源下载",
    coverImage: "https://readdy.ai/api/search-image?query=A%20curated%20collection%20of%20digital%20resources%20displayed%20on%20a%20clean%20desk%2C%20design%20assets%2C%20code%20snippets%2C%20ebooks%20floating%20in%20an%20organized%20grid%2C%20warm%20cream%20and%20coral%20accents%2C%20minimalist%20flat%20lay%20style%2C%20soft%20natural%20light%2C%20editorial%20photography%20with%20warm%20tones&width=1600&height=900&seq=article-resources&orientation=landscape",
    author: "17c.c 编辑部",
    publishDate: "2026-07-15",
    readTime: "12 分钟",
    tags: ["资源推荐", "年度精选", "免费资源"],
    featured: true,
  },
  {
    slug: "xiaolv-gongju-hengping-2026",
    title: "2026 效率工具横评：哪款最适合你的工作流",
    excerpt: "全面对比市面上主流效率工具，从笔记应用到项目管理，帮你找到最佳搭档。",
    content: `<h2>效率工具概览</h2><p>在数字化工作时代，选择合适的效率工具至关重要。我们从功能、易用性、价格等多个维度，对比了当前最受欢迎的效率工具。</p><h3>笔记类工具</h3><p>Notion、Obsidian、飞书文档各有千秋，适合不同使用场景。</p><h3>项目管理工具</h3><p>从轻量级的 Trello 到企业级的 Jira，我们帮您做出明智选择。</p>`,
    category: "gongju",
    categoryName: "效率工具",
    coverImage: "https://readdy.ai/api/search-image?query=Multiple%20productivity%20apps%20displayed%20on%20floating%20screens%20arranged%20in%20a%20comparison%20layout%2C%20warm%20minimalist%20design%2C%20cream%20background%20with%20coral%20accents%2C%20clean%20modern%20interface%2C%20soft%20ambient%20lighting%2C%20editorial%20product%20comparison%20style&width=1600&height=900&seq=article-tools&orientation=landscape",
    author: "17c.c 工具评测组",
    publishDate: "2026-07-20",
    readTime: "15 分钟",
    tags: ["效率工具", "工具测评", "工作流"],
    featured: false,
  },
  {
    slug: "shenghuo-xiaojiqiao-daquan",
    title: "生活小技巧大全：让日常变得更轻松",
    excerpt: "收集整理最实用的生活妙招，从居家清洁到厨房烹饪，每个技巧都经过验证。",
    content: `<h2>生活妙招集锦</h2><p>生活中的小智慧往往能带来大改变。我们收集了数十条经过验证的生活技巧，让您的日常更加轻松愉快。</p><h3>居家清洁</h3><p>白醋加小苏打的清洁组合，能解决大部分厨房油污问题。</p><h3>厨房烹饪</h3><p>学会这些切菜技巧，让备菜时间缩短一半。</p>`,
    category: "shenghuo",
    categoryName: "生活百科",
    coverImage: "https://readdy.ai/api/search-image?query=Cozy%20home%20lifestyle%20scene%20with%20organized%20cleaning%20tools%20and%20fresh%20kitchen%20ingredients%2C%20warm%20natural%20light%2C%20cream%20and%20soft%20green%20color%20palette%2C%20minimalist%20interior%2C%20flat%20lay%20photography%20style%2C%20calm%20and%20clean%20aesthetic&width=1600&height=900&seq=article-life&orientation=landscape",
    author: "17c.c 生活组",
    publishDate: "2026-08-02",
    readTime: "6 分钟",
    tags: ["生活小技巧", "居家", "实用妙招"],
    featured: false,
  },
  {
    slug: "AI-jishu-fazhan-qushi-2026",
    title: "AI 技术发展趋势 2026：从大模型到智能体",
    excerpt: "深度解读人工智能领域最新技术突破与未来方向，把握 AI 时代脉搏。",
    content: `<h2>AI 技术前沿</h2><p>2026 年，人工智能领域持续高速发展。从大语言模型的持续进化，到 AI Agent 的兴起，技术变革正在重塑各个行业。</p><h3>大模型新突破</h3><p>参数规模的竞争已经转向效率与专业化的比拼，小型高效模型正在崛起。</p><h3>AI 应用落地</h3><p>从代码生成到内容创作，AI 正在成为每个人的得力助手。</p>`,
    category: "keji",
    categoryName: "科技前沿",
    coverImage: "https://readdy.ai/api/search-image?query=Futuristic%20AI%20technology%20concept%20with%20abstract%20neural%20network%20visualization%20in%20warm%20coral%20and%20cream%20tones%2C%20minimalist%20tech%20illustration%2C%20soft%20glowing%20nodes%20connected%20by%20elegant%20lines%2C%20clean%20geometric%20patterns%2C%20modern%20scientific%20aesthetic&width=1600&height=900&seq=article-ai&orientation=landscape",
    author: "17c.c 科技组",
    publishDate: "2026-08-03",
    readTime: "9 分钟",
    tags: ["人工智能", "AI趋势", "技术前沿"],
    featured: false,
  },
  {
    slug: "17cc-anquan-yinsi-baohu",
    title: "17c.c 安全与隐私保护：您的数据我们用心守护",
    excerpt: "了解 17c.c 在数据安全与用户隐私保护方面的承诺与实践，让您用得放心。",
    content: `<h2>安全承诺</h2><p>在 17c.c，我们深知数据安全与隐私保护的重要性。我们采用行业领先的技术手段，全方位保障您的信息安全。</p><h3>数据加密</h3><p>所有数据传输均采用 HTTPS 加密协议，确保您的浏览记录和个人信息不被窃取。</p><h3>隐私政策</h3><p>我们严格遵守相关法律法规，不会在未经您允许的情况下向第三方共享您的个人信息。</p>`,
    category: "zixun",
    categoryName: "最新资讯",
    coverImage: "https://readdy.ai/api/search-image?query=Cybersecurity%20concept%20with%20a%20shield%20and%20lock%20icon%20on%20a%20warm%20cream%20background%2C%20minimalist%20design%2C%20soft%20geometric%20shapes%2C%20trustworthy%20and%20secure%20aesthetic%2C%20subtle%20gradients%2C%20professional%20corporate%20style&width=1600&height=900&seq=article-security&orientation=landscape",
    author: "17c.c 安全团队",
    publishDate: "2026-07-25",
    readTime: "7 分钟",
    tags: ["安全", "隐私保护", "数据加密"],
    featured: false,
  },
  {
    slug: "xin-shou-ru-men-zhi-nan",
    title: "17c.c 新手指南：五步快速上手平台",
    excerpt: "专为新用户打造的快速入门指南，只需五个简单步骤，轻松玩转 17c.c。",
    content: `<h2>五步快速上手</h2><p>欢迎加入 17c.c！只需以下五个步骤，您就能快速熟悉平台功能。</p><h3>第一步：浏览首页</h3><p>进入 17c.c 官网后，您将看到精心编排的首页内容，包含热门推荐和分类导航。</p><h3>第二步：探索分类</h3><p>点击分类标签，浏览您感兴趣的内容板块。</p><h3>第三步：使用搜索</h3><p>在搜索框中输入关键词，快速定位目标内容。</p><h3>第四步：阅读文章</h3><p>点击感兴趣的文章，享受流畅的阅读体验。</p><h3>第五步：收藏分享</h3><p>将优质内容收藏起来，或分享给朋友。</p>`,
    category: "jiaocheng",
    categoryName: "实用教程",
    coverImage: "https://readdy.ai/api/search-image?query=A%20friendly%20beginner%20guide%20illustration%20showing%20five%20simple%20steps%20with%20numbered%20icons%2C%20warm%20orange%20and%20cream%20color%20palette%2C%20clean%20minimalist%20flat%20design%2C%20welcoming%20and%20easy%20to%20follow%20layout%2C%20soft%20shadows%2C%20educational%20illustration%20style&width=1600&height=900&seq=article-beginner&orientation=landscape",
    author: "17c.c 教程组",
    publishDate: "2026-08-04",
    readTime: "5 分钟",
    tags: ["新手入门", "17c.c", "使用教程"],
    featured: false,
  },
  {
    slug: "qukuailian-Web3-fazhan",
    title: "区块链与 Web3：2026 年去中心化技术全景解读",
    excerpt: "深入浅出讲解区块链与 Web3 技术生态，从 DeFi 到 NFT，全面把握去中心化技术发展脉络。",
    content: `<h2>Web3 全景</h2><p>Web3 作为下一代互联网的核心概念，正在重新定义数字世界的运行方式。本文从基础概念出发，带您全面了解这个快速发展的领域。</p><h3>区块链基础</h3><p>去中心化账本技术是 Web3 的基石，理解其运作原理对于把握整个生态至关重要。</p><h3>DeFi 与 NFT</h3><p>去中心化金融和数字藏品是 Web3 领域最活跃的应用场景，正在创造全新的经济模式。</p>`,
    category: "keji",
    categoryName: "科技前沿",
    coverImage: "https://readdy.ai/api/search-image?query=Abstract%20blockchain%20and%20Web3%20technology%20visualization%20with%20interconnected%20nodes%20and%20blocks%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20minimalist%20geometric%20design%2C%20soft%20ambient%20glow%2C%20clean%20modern%20tech%20aesthetic&width=1600&height=900&seq=article-web3&orientation=landscape",
    author: "17c.c 科技组",
    publishDate: "2026-07-18",
    readTime: "11 分钟",
    tags: ["区块链", "Web3", "去中心化", "加密货币"],
    featured: false,
  },
];

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter((a) => a.category === categorySlug);
}

export function getFeaturedArticles(): Article[] {
  return articles.filter((a) => a.featured);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getRelatedArticles(article: Article, limit: number = 3): Article[] {
  return articles
    .filter((a) => a.slug !== article.slug && a.category === article.category)
    .slice(0, limit);
}